(() => {
  const visibleLabel = '¿Te ayudamos con la talla?';
  const observed = new WeakSet();
  let activator;
  // Inbox can render directly or through its newer nested agent runtime.
  function sync() {
    const label = visibleLabel;
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    if (!root) return;
    const roots = [root, root.querySelector('shopify-agent-runtime')?.shadowRoot].filter(Boolean);
    for (const tree of roots) {
      if (!observed.has(tree)) {
        observed.add(tree);
        new MutationObserver(sync).observe(tree, { childList: true, subtree: true, characterData: true });
      }
      const button = tree.querySelector('button[part~="activator"]');
      if (!button) continue;
      activator = button;
      button.querySelector('[data-dm-chat-invitation]')?.remove();
      button.style.padding = '12px 16px';
      button.style.minHeight = '48px';
      button.style.borderRadius = '999px';
      button.style.gap = '8px';
      button.style.fontSize = '14px';
      button.style.lineHeight = '20px';
      const text = button.querySelector('.activator__label');
      if (text) {
        text.style.display = 'inline-block';
        text.style.minWidth = '0';
        text.style.width = 'auto';
        text.style.minHeight = '20px';
        text.style.fontSize = '14px';
        text.style.lineHeight = '20px';
        text.style.textAlign = 'center';
        text.setAttribute('aria-hidden', 'true');
      }
      if (text && text.textContent !== label) text.textContent = label;
      if (button.getAttribute('aria-label') !== 'Abrir chat de ayuda con tallas') button.setAttribute('aria-label', 'Abrir chat de ayuda con tallas');
      // Leave Inbox's unread indicator untouched: it represents real replies.
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-dm-size-chat]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    sync();
    if (!activator?.isConnected) return; // Contact page remains available if Inbox cannot load.
    event.preventDefault();
    if (activator.getAttribute('aria-expanded') !== 'true') setTimeout(() => activator?.click(), 0);
  });

  sync();
  let attempts = 0;
  const timer = setInterval(() => {
    sync();
    if (activator?.isConnected || ++attempts >= 60) clearInterval(timer);
  }, 1000);
})();

